import React from "react";
import classnames from "classnames";
import {useDispatch, useSelector} from "react-redux";

import {openRequestAssistanceModal} from "shared/reduxElements/slices/showRequestAssistance";
import {getMeta} from "shared/networking/tools";
import ButtonInput from "shared/components/ButtonInput";

import phoneIconLight from "apps/QuoterApp/assets/images/Phone icon - Light.svg";
import emailIconLight from "apps/QuoterApp/assets/images/Email icon - Light.svg";
import contactIconLight from "apps/QuoterApp/assets/images/Contact icon - Light.svg";
import phoneIcon from "shared/assets/images/Phone icon.svg";
import downloadIcon from "shared/assets/images/Download.svg";

import './styles.scss';


function ContactInfo({className}) {
    const dispatch = useDispatch();

    const agency = {
        phone: getMeta('agencyPhone'),
        email: getMeta('agencyEmail'),
        logo: getMeta('agencyLogo'),
        name: getMeta('agencyName'),
    };
    const agent = {
        email: getMeta('agentEmail'),
        name: getMeta('agentName'),
        phone: getMeta('agentPhone'),
    };

    const {result: {savePdf}} = useSelector(state => state.quoteRequest);

    // Prioritize agent data over agency data when available
    let phone = agent.phone ? agent.phone : agency.phone;
    let email = agent.email ? agent.email : agency.email;

    // Button should not appear in Assistance Page
    const isAssistancePage = window.location.href.indexOf("/assistance/") !== -1;

    return <div className={classnames("ContactInfo", className)}>
        <img src={agency.logo} alt={agency.name}/>

        {agent.email &&
            <div className={"ContactInfo__Item"}>
                <b>Your Agent Contact Info:</b>
            </div>
        }
        {phone &&
            <div className={"ContactInfo__Item"}>
                <img src={phoneIconLight} alt={"Phone"}/>
                <a href={`tel:${phone}`}>{phone}</a>
            </div>
        }
        {email &&
            <div className={"ContactInfo__Item"}>
                <img src={emailIconLight} alt={"Email"}/>
                {agent.name ?
                    <span>
                        {agent.name}<br/>
                        <a href={`mailto:${email}`}>{email}</a>
                        </span> :
                    <a href={`mailto:${email}`}>{email}</a>
                }
            </div>
        }

        <div className={"ContactInfo__Item"}>
            <img src={contactIconLight} alt={"Support"}/>
            {/* TODO: GET TEXT FROM GET COOKIES */}
            <span>Questions or unsure of the best product? We’re happy to discuss your options and review the life insurance process in more detail – just email or calls us. Our licensed advisors are waiting to assist.</span>
        </div>

        {isAssistancePage ? null :
            <div className={"ContactInfo__ButtonContainer"}>
                {savePdf
                    ? <ButtonInput
                        className={"ContactInfo__SavePdf"}
                        outline={true}
                        onClick={() => {
                            window.open(savePdf);
                        }}
                    >
                        <img src={downloadIcon} alt={"Download"}/>
                        <span>Download PDF</span>
                    </ButtonInput>
                    : <div className={"ContactInfo__SavePdf"}/>}

                <ButtonInput
                    className={"ContactInfo__RequestAssistance"}
                    onClick={() => dispatch(openRequestAssistanceModal())}
                >
                    <img src={phoneIcon} alt={"Phone"}/>
                    <span>Request Assistance</span>
                </ButtonInput>
            </div>
        }

    </div>;
}

export default ContactInfo;
